import { z } from 'zod/v4-mini';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
export const ZodTaskStats = matchingZodObject({
    status: z.literal(['idle', 'pending']),
    remainingTasks: z.number(),
    totalTasks: z.number(),
    totalErrors: z.number(),
    totalWarnings: z.number(),
});
//# sourceMappingURL=TaskStats.js.map